export const UAH_CODE = 'uah';
export const DEFAULT_CURRENCY = UAH_CODE;
